<template>
    <div class="account-deletion-page">

        <!-- AppHeaderNew -->
        <AppHeaderNew />

        <div class="container">

            <div class="card">

                <div class="page-title">
                    <h1>aPay Account Deletion</h1>
                    <p>Provided by AmejPay</p>
                </div>

                <div class="content">

                    <section class="section">
                        <h2>
                            <i class="fa fa-trash"></i>
                            Delete Your Account
                        </h2>

                        <p>
                            AmejPay respects your privacy and gives every user the
                            ability to permanently delete their aPay account directly
                            from the mobile application.
                        </p>

                        <p>
                            Please read the instructions below before submitting your
                            account deletion request.
                        </p>
                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-exclamation-circle"></i>
                            Before You Delete
                        </h2>

                        <div class="notice">

                            <ul>
                                <li>Transfer your remaining wallet balance to another AmejPay user.</li>
                                <li>Complete all pending transactions.</li>
                                <li>Account deletion is permanent and cannot be undone.</li>
                            </ul>

                        </div>

                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-list-ol"></i>
                            Account Deletion Process on Mobile App
                        </h2>

                        <ol class="steps">

                            <li>Login to your <strong>aPay</strong> account on your <strong>aPay</strong> Mobile App.</li>

                            <li>
                                Transfer your remaining wallet balance to another
                                <strong>AmejPay</strong> user.
                            </li>

                            <li>Go to the <strong>Profile</strong> page.</li>

                            <li>Tap the <strong>Delete Account</strong> button.</li>

                            <li>
                                Enter the following information:

                                <ul class="sub-list">
                                    <li>Your Accout <strong>Password/PIN</strong> Number</li>
                                    <li>Reason for deleting your account</li>
                                    <li>Tick on 'I undestand ...' box</li>
                                </ul>

                            </li>

                            <li>
                                Tap the
                                <strong>Delete My Account</strong>
                                button.
                            </li>

                            <li>
                                Your account will be permanently deleted after successful verification.
                            </li>

                        </ol>

                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-user-times"></i>
                            What Happens After Deletion?
                        </h2>

                        <ul class="info-list">

                            <li>
                                <i class="fa fa-check-circle"></i>
                                Your aPay account will be permanently deleted.
                            </li>

                            <li>
                                <i class="fa fa-check-circle"></i>
                                You will no longer be able to log in.
                            </li>

                            <li>
                                <i class="fa fa-check-circle"></i>
                                Your personal profile information will be deleted.
                            </li>

                            <li>
                                <i class="fa fa-check-circle"></i>
                                Deleted accounts cannot be recovered.
                            </li>

                            <li>
                                <i class="fa fa-check-circle"></i>
                                You will need to register again if you wish to use aPay in the future.
                            </li>

                        </ul>

                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-database"></i>
                            Data Retention
                        </h2>

                        <p>
                            Most personal information associated with your account
                            will be permanently deleted after your request is processed.
                        </p>

                        <p>
                            Certain information may be retained where required by law,
                            including:
                        </p>

                        <ul class="info-list">

                            <li>
                                <i class="fa fa-angle-right"></i>
                                Financial transaction records
                            </li>

                            <li>
                                <i class="fa fa-angle-right"></i>
                                Regulatory compliance records
                            </li>

                            <li>
                                <i class="fa fa-angle-right"></i>
                                Fraud prevention and security investigations
                            </li>

                            <li>
                                <i class="fa fa-angle-right"></i>
                                Dispute resolution
                            </li>

                        </ul>

                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-clock-o"></i>
                            Processing Time
                        </h2>

                        <p>
                            Most deletion requests are processed immediately after
                            successful verification within the application.
                        </p>

                        <p>
                            In some cases, processing may take up to
                            <strong>7 business days</strong>.
                        </p>

                    </section>

                    <section class="section">

                        <h2>
                            <i class="fa fa-life-ring"></i>
                            Need Assistance?
                        </h2>

                        <div class="contact">

                            <p><strong>Company:</strong> AmejPay</p>

                            <p><strong>Application:</strong> aPay</p>

                            <p>
                                <strong>Email:</strong>
                                <a href="mailto:support@amejpay.com">
                                    support@amejpay.com
                                </a>
                            </p>

                            <p>
                                If you experience any issue while deleting your account,
                                please contact our support team.
                            </p>

                        </div>

                    </section>

                </div>

            </div>

        </div>

        <!-- FooterNew -->
        <AppFooterNew />

    </div>
</template>

<script>
import AppHeaderNew from "../reuseable_components/HeaderNew";
import AppFooterNew from "../reuseable_components/FooterNew";
export default {
    name: "AccountDeletion",
    components: {
        AppHeaderNew,
        AppFooterNew,
    },
};
</script>

<style scoped>

.account-deletion-page{
    background:#f5f7fb;
    padding-top:50px;
    min-height:100vh;
    margin-top: 40px;
}

.container{
    width:92%;
    max-width:1000px;
    margin:auto;
}

.card{
    background:#ffffff;
    border-radius:10px;
    overflow:hidden;
    box-shadow:0 8px 25px rgba(0,0,0,.08);
}

.page-title{
    text-align:center;
    padding:40px 25px;
    border-bottom:1px solid #eeeeee;
}

.page-title h1{
    color:#0066cc;
    font-size:36px;
    margin-bottom:10px;
}

.page-title p{
    color:#777;
}

.content{
    padding:35px;
}

.section{
    margin-bottom:40px;
}

.section h2{
    color:#0066cc;
    margin-bottom:18px;
    border-left:5px solid #0066cc;
    padding-left:12px;
    font-size:26px;
}

.notice{
    background:#fff8e5;
    border-left:5px solid #ffb400;
    padding:18px;
    border-radius:6px;
}

.notice ul{
    margin-left:20px;
}

.steps{
    counter-reset:step;
}

.steps > li{
    list-style:none;
    position:relative;
    margin-bottom:20px;
    padding-left:60px;
    min-height:42px;
}

.steps > li:before{
    counter-increment:step;
    content:counter(step);
    position:absolute;
    left:0;
    top:0;
    width:40px;
    height:40px;
    line-height:40px;
    text-align:center;
    background:#0066cc;
    color:#fff;
    border-radius:50%;
    font-weight:bold;
}

.sub-list{
    margin-top:10px;
    margin-left:20px;
}

.info-list{
    list-style:none;
    padding:0;
}

.info-list li{
    padding:12px 0;
    border-bottom:1px solid #eeeeee;
}

.info-list li:last-child{
    border-bottom:none;
}

.info-list i{
    width:22px;
    color:#0066cc;
}

.contact{
    background:#f4f9ff;
    padding:20px;
    border-radius:8px;
}

.contact p{
    margin-bottom:10px;
}

a{
    color:#0066cc;
    text-decoration:none;
}

a:hover{
    text-decoration:underline;
}

@media (max-width:768px){

    .account-deletion-page{
        padding:20px 0;
        margin-top: 60px;
    }

    .content{
        padding:20px;
    }

    .page-title{
        padding:25px 15px;
    }

    .page-title h1{
        font-size:28px;
    }

    .section h2{
        font-size:22px;
    }

    .steps > li{
        padding-left:55px;
    }

}
</style>